export default "__VITE_ASSET__6bf585c5__"